import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import { Link as RouterLink } from 'react-router-dom'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid, 
  IconButton,
  TextField, 
  Typography,
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import SaveIcon from '@mui/icons-material/Save'
import SaveAsIcon from '@mui/icons-material/SaveAs'

import { DataGrid, esES } from '@mui/x-data-grid'


const Schools = (props) => {
  const { firestore } = useFirebase()
  const {
    addDocToCollection,
    deleteDocFromCollection,
    updateDocFromCollection,
    getSchools,
    schools
  } = firestore

  const [loading, setLoading] = useState(false)

  const [rows, setRows] = useState([])

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 180,
      flex: 1,
    },
    { 
      field: 'director', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Director'}</b>
      ), 
      minWidth: 240,
      flex: 4,
    },
    { 
      field: 'id',
      headerName: '',
      flex: 0,
      renderCell: (params) => (
        <IconButton component={RouterLink} to={`${params.value}`}>
          <ChevronRightIcon />
        </IconButton>
      ),
      type: 'singleSelect',
      align: 'right',
      sortable: false,
      filterable: false,
    },
  ]

  useEffect(() => {
    getSchools()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (schools === undefined) return

    var data = []
    schools.forEach((school) => {
      data.push({
        'id': school['id'],
        'description': school['description'],
        'name': school['name'],
        'director': school['director'] !== undefined ? school['director']['name'] : 'Sin asignar'
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schools])

  const [name, setName] = useState('')
  const handleNameChanged = (event) => {
    setName(event.target.value)
  }

  const [description, setDescription] = useState('')
  const handleDescriptionChanged = (event) => {
    setDescription(event.target.value)
  }

  const [selectionModel, setSelectionModel] = useState([])

  const handleRowClick = (event) => {
    const id = event.id
    const row = event.row
    if (selectionModel.includes(id)) {
      clear()
    } else {
      setName(row.name)
      setDescription(row.description)
    }
  }

  const clear = () => {
    setSelectionModel([])
    setName('')
    setDescription('')
  }

  const onCreateOrEdit = async () => {
    setLoading(true)
    
    const data = {
      'name': name,
      'description': description
    }

    if (selectionModel.length === 0) {
      await addDocToCollection('schools', data)
    } else {
      const id = selectionModel[0]
      await updateDocFromCollection('schools', id, data)
    }

    clear()
    setLoading(false)
  }

  const onDelete = async () => {
    const id = selectionModel[0]
    await deleteDocFromCollection('schools', id)
    clear()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Escuelas</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1' gutterBottom>
                  <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'NUEVA'} ESCUELA</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={name}
                  onChange={handleNameChanged}
                  placeholder='Nombre de la escuela'
                  label='Nombre'
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={description}
                  onChange={handleDescriptionChanged}
                  placeholder='Describe la escuela'
                  label='Descripción'
                  InputLabelProps={{ shrink: true }}
                  multiline
                  maxRows={6}
                  fullWidth
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: 'end', p: 0, pt: 2 }}>
            {
              selectionModel.length > 0 ? (
                <Button color='warningRed' disableElevation variant='contained' onClick={onDelete} sx={{ mr: 'auto' }}>
                  <b style={{ fontWeight: 900 }}>BORRAR</b>
                </Button>
              ) : null
            }
            {
              name !== '' || description !== '' ? (
                <Button color='secondary' disableElevation variant='contained' onClick={clear}>
                  <b style={{ fontWeight: 900 }}>CANCELAR</b>
                </Button>
              ) : null
            }
            <LoadingButton disabled={ name === '' || description === '' } color='primary' disableElevation variant='contained' onClick={onCreateOrEdit} loading={loading} loadingPosition='start' startIcon={loading ? <SaveAsIcon /> : <SaveIcon />}>
              {
                loading ? <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITANDO' : 'CREANDO'}</b> : <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'CREAR'}</b>
              }
            </LoadingButton>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} md={6} lg={8}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE ESCUELAS</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  autoHeight
                  // disableColumnMenu
                  columns={columns}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  pageSize={10}
                  rows={rows}
                  rowsPerPageOptions={[10]}
                  sx={{ borderWidth: 0 }}
                  onRowClick={handleRowClick}
                  onSelectionModelChange={setSelectionModel}
                  selectionModel={selectionModel}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Schools